document.addEventListener("DOMContentLoaded", function() {
   const seeMoreBtn = document.getElementById("see-more-btn");
   const collapsibleContent = document.querySelector(".collapsible-content");

   if (seeMoreBtn && collapsibleContent) {
      seeMoreBtn.addEventListener("click", function() {
         collapsibleContent.classList.toggle("expanded");

         // Change button text based on state
         if (collapsibleContent.classList.contains("expanded")) {
            seeMoreBtn.textContent = "See Less";
         } else {
            seeMoreBtn.textContent = "See More";
         }
      });
   }
});
